import { Component, OnInit, computed, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
    ImportsMonitoringChannelDrilldownImport,
    ImportsMonitoringListingImportItemDetails,
    ProcessedImportsMonitoringItemDetails,
} from 'exports/interfaces/imports-monitoring-channel.interface';
import { BaseTooltip } from 'shared/abstract/base-tooltip';

@Component({
    selector: 'app-import-partial-success-status-display-tooltip',
    imports: [TranslateModule],
    templateUrl: './import-partial-success-status-display-tooltip.component.html',
    styleUrl: './import-partial-success-status-display-tooltip.component.scss',
})
export class ImportPartialSuccessStatusDisplayTooltipComponent extends BaseTooltip implements OnInit {
    public data: ImportsMonitoringChannelDrilldownImport | null = null;

    processedData = signal<ProcessedImportsMonitoringItemDetails[] | null>(null);

    ngOnInit(): void {
        this.processDataForTooltip();
    }

    successCount = computed(() => this.processedData()?.filter((s) => s.isSuccessful).length);
    errorCount = computed(() => this.processedData()?.filter((s) => !s.isSuccessful).length);

    processDataForTooltip() {
        if (!this.data) return;

        this.processedData.set(
            this.data.itemDetails.map((item: ImportsMonitoringListingImportItemDetails) => {
                const processedItem: ProcessedImportsMonitoringItemDetails = {
                    featureGroupId: item.featureGroupId,
                    featureGroupName: item.featureGroupName,
                    isSuccessful: item.details.every((detail) => detail.isSuccessful),
                    children: item.details.filter((detail) => {
                        return detail.name !== item.featureGroupName;
                    }),
                };
                const totalFaieldChildren = processedItem.children.filter((child) => !child.isSuccessful);
                processedItem.failedChildren = totalFaieldChildren.slice(0, 5);
                processedItem.extraFailedChildren = totalFaieldChildren.length > 5 ? totalFaieldChildren.length - 5 : 0;
                return processedItem;
            }),
        );
        this.processedData.update((data) => data?.sort((a, b) => a.featureGroupName.localeCompare(b.featureGroupName)) || null);
    }

    protected clickInside(event: any) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
    }
}
